








import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import PatientHeader from "@/components/patient/PatientHeader.vue";
import PatientTimeline from "@/components/patient/PatientTimeline/Index.vue";
import { patients, patientEvents } from "@/api/mock";

@Component({
  components: {
    PatientHeader,
    PatientTimeline
  }
})
export default class PatientPage extends Vue {
  @Prop({
    required: true
  })
  public patientId!: number;

  get patient() {
    return patients[this.patientId];
  }

  get events() {
    return patientEvents(this.patientId);
  }
}
